export default function trierIntervenants(devisCommande) {
  devisCommande.intervenants.sort((a, b) => {
    if (a.payeur > b.payeur) return -1;
    if (a.payeur === b.payeur) {
      if (a.annonceur > b.annonceur) return -1;
      if (a.annonceur === b.annonceur) {
        if (a.mandataire > b.mandataire) return -1;
        if (a.mandataire === b.mandataire) {
          if (a.donneurOrdre > b.donneurOrdre) return -1;
          if (a.donneurOrdre === b.donneurOrdre) return 0;
        }
      }
    }
    return 1;
  });
}
